var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.41176,
    height: 31,
    fill: "#D5D5D5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.11768,
    y: 8.61084,
    width: 17.0588,
    height: 6.88889,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.11768,
    y: 18.9443,
    width: 20.4706,
    height: 12.0556,
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowleft);
export default __webpack_public_path__ + "static/media/icon _arrow left.4ce6f28d15c0ccdd87416aeb29bee385.svg";
export { ForwardRef as ReactComponent };